<template>
  <div class="create__global__alert">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(saveGlobalAlert)">
        <div class="form-group">
          <label>Users</label>
          <span class="float-right">
            <a v-if="!showDeselectAll" href="#" @click="selectAllUser">Select all</a>
            <a v-if="showDeselectAll" href="#" @click="deSelectAllUser">Deselect all</a>
          </span>
          <ValidationProvider mode="passive" rules="required" v-slot="{ errors }">
            <multiselect
              ref="alertUser"
              v-model="alertUser"
              track-by="id"
              label="name"
              open-direction="bottom"
              :options="allActiveUsers"
              :show-labels="false"
              :multiple="true"
              :allowEmpty="false"
              :close-on-select="false"
              :hide-selected="false"
              :preserve-search="true"
              :clear-on-select="true"
            ></multiselect>
            <span class="validate-error text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <label>Alert Type</label>
          <multiselect
            ref="alertType"
            v-model="alertType"
            track-by="id"
            label="name"
            open-direction="bottom"
            :options="alertTypes"
            :show-labels="false"
            :multiple="false"
            :allowEmpty="false"
            :close-on-select="true"
            :hide-selected="false"
            :preserve-search="true"
            :clear-on-select="true"
          ></multiselect>
        </div>
        <div class="form-group">
          <label>Title</label>
          <ValidationProvider mode="passive" rules="required" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="Title" v-model="alertTitle" />
            <span class="validate-error text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <label>Message</label>
          <ValidationProvider mode="passive" rules="required" v-slot="{ errors }">
            <ckeditor
              editorUrl="/js/ckeditor/ckeditor.js"
              v-model="alertMessage"
              placeholder="Message"
              :config="editorConfig"
            ></ckeditor>
            <span class="validate-error text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <b-button class="header-filter-btns" type="submit" variant="theme">
            Send Alert
            <i class="fas text-primary fa-paper-plane fa-fw float-right"></i>
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      alertUser: [],
      alertTitle: "",
      alertMessage: "",
      alertType: {
        id: "general",
        name: "General",
      },
      editorConfig: {
        toolbar:  [
          { name: 'document', groups: [ 'mode' ], items: [ 'Source' ] },
          { name: 'clipboard', groups: [ 'clipboard', 'undo' ], items: [ 'Cut', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo' ] },                                        
          { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ], items: [ 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat' ] },
          { name: 'paragraph', groups: [ 'list', 'blocks', 'align' ], items: [ 'NumberedList', 'BulletedList', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
          { name: 'links', items: [ 'Link', 'Unlink' ] },
          { name: 'insert', items: [ 'Table', 'HorizontalRule' ] },
          { name: 'styles', items: [ 'Styles' ] },
          { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
          { name: 'tools', items: [ 'Maximize' ] }
        ],
      },
      showDeselectAll: false,
    };
  },
  mounted() {
    $('#createGlobalAlert .modal-content').removeAttr('tabindex');
    this.fetchUsers();
    this.fetchActiveUsers();
    this.fetchGlobalAlertTypes();
  },
  methods: {
    ...mapActions(["fetchUsers", "fetchActiveUsers", "fetchGlobalAlertTypes"]),
    saveGlobalAlert() {
      let that = this;
      this.$store
        .dispatch("saveGlobalAlert", {
          alertUser: this.alertUser,
          alertTitle: this.alertTitle,
          alertMessage: this.alertMessage,
          alertType: this.alertType,
        })
        .then(function () {
          that.$bvModal.hide("createGlobalAlert");
          that.alertUser = [];
          that.alertTitle = "";
          that.alertMessage = "";
        });
    },
    selectAllUser() {
      this.showDeselectAll = true;
      this.alertUser = this.allActiveUsers;
    },
    deSelectAllUser() {
      this.showDeselectAll = false;
      this.alertUser = [];
    },
  },
  computed: {
    ...mapGetters(["allUsers", "allActiveUsers", "globalAlertTypes"]),
    alertTypes() {
      return this.globalAlertTypes.map(type => ({
        id: type.id,
        name: type.type,
        slug: type.slug
      }));
    }
  },
  watch: {
    alertTypes(newTypes) {
      if (newTypes.length > 0 && !this.alertType.slug) {
        this.alertType = newTypes.find(t => t.slug === 'general') || newTypes[0];
      }
    }
  },
};
</script>

<style>
</style>